import districtsService from "api/districtsService";
import { useMutation } from "react-query";

import { IUpdateDistrictBody } from "types/district";

const useUpdateDistrictMutation = () => {
  return useMutation(async(data: IUpdateDistrictBody) => {
    try {
      const res = await districtsService.udpateDistrict(data)

      return res.data
    } catch(err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useUpdateDistrictMutation